export default __webpack_public_path__ + "static/icon-b64c5d8148b6e2cd921b87324abf1177.png";